import { FeaturedProperty } from './FeaturedProperty';
import { useProperties } from '@providers';
import { EmblaCarousel } from '@shared-components';
import { randomElements } from '@utils';
import { HomeSectionHeading } from './HomeSectionHeading.tsx';
import { useTranslation } from 'react-i18next';

export const FeaturedPropertiesArea = () => {
  const { properties } = useProperties();
  const { t } = useTranslation();
  const featuredProperties = randomElements(properties, 6);

  return (
    <div className='ltn__product-slider-area ltn__product-gutter pt-115 pb-90'>
      <div className='container'>
        <HomeSectionHeading
          title={t('featuredProperties.title')}
          subtitle={t('featuredProperties.subtitle')}
        />
        <EmblaCarousel
          arrows
          autoplay
          className='embla-carousel--product-cards embla-carousel--hide-arrows-md-down ltn__product-slider-item-three-active slick-arrow-1'
          dots
          options={{
            align: 'start',
            loop: featuredProperties.length > 1,
          }}
        >
          {featuredProperties.map((prop) => (
            <FeaturedProperty key={prop.id} {...prop} />
          ))}
        </EmblaCarousel>
      </div>
    </div>
  );
};
